import apiClient from '../apiClient';
import { GET_TOUR_OPERATOR_MARGIN_BY_ID_URL } from '../apiUrl';

const getTourOperatorMarginByIdApi = Id => {
  return apiClient.get(GET_TOUR_OPERATOR_MARGIN_BY_ID_URL(Id));
};

export default getTourOperatorMarginByIdApi;
